import { useState, useContext, useEffect } from "react";
import { AuthContext } from "../../context/AuthProvider";
import useToastNotification from "../../hooks/useToastNotification";

const GotoLink = () => {
  const [eid, setEid] = useState("");
  const [pwd, setPwd] = useState("");

  const [strictInt, setStrictInt] = useState("");

  const { login, disableSubmit } = useContext(AuthContext);
  const { notifyError } = useToastNotification();

  const submitLogin = (e) => {
    e.preventDefault();

    if (eid && pwd) {
      login({ eid, pwd });
    } else {
      notifyError("The Username or Password is incorrect");
    }
  };

  return (
    <form>
      <div className="form-group">
        <b>Sign in through MicroStatus</b>
      </div>
      <div className="form-group">
        <b>
          Log to{" "}
          {/* <a href="https://microsourcing.microstatus.com/">MicroStatus</a> and */}
          {/* <a href="https://microstatus-uat.microsourcing.ph/">MicroStatus</a> */}
          <a href="https://microsourcing.microstatus.com/">MicroStatus</a>{" "}
          and go to <i>Links MicroRefer</i>
        </b>
      </div>
    </form>
  );
};

export default GotoLink;
